export function AddXLevels(data) {
  const nodeMap = new Map();
  const xLevels = new Map();

  // Build nodeId -> block map
  data?.forEach((block) => {
    const nodeId = block?.currentNode?.nodeId;
    if (nodeId) nodeMap.set(nodeId, block);
  });

  // Recursive x_level calculator using array functions
  const calculateLevel = (node) => {
    const nodeId = node?.currentNode?.nodeId;
    if (!nodeId) return 1;

    if (xLevels.has(nodeId)) {
      return xLevels.get(nodeId);
    }

    const prevLevel = (node.previousNodes || [])
      .map((prev) => {
        const prevNode = nodeMap.get(prev.nodeId);
        return prevNode ? calculateLevel(prevNode) : 0;
      })
      .reduce((max, lvl) => Math.max(max, lvl), 0);

    const level = prevLevel + 1 || 1;
    xLevels.set(nodeId, level);
    return level;
  };

  return data?.map((block) => {
    const level = calculateLevel(block);
    return {
      ...block,
      x_level: level,
    };
  });
}
